import { apiCall } from "./Interceptor";

const GET_ALL_HOLDING_COMPANY_LIST = "/holding-company/getAll/public";

const getAllHoldingCompanyList = async () => {
    const response = await apiCall.get(GET_ALL_HOLDING_COMPANY_LIST);
    return response;
}

export default {
    getAllHoldingCompanyList,
};
